(() => {
  const desktopQuery = window.matchMedia('(min-width: 990px) and (hover: hover)');

  const closeDropdown = (details) => {
    details.removeAttribute('open');
    details.querySelector(':scope > summary')?.setAttribute('aria-expanded', 'false');
  };

  const openDropdown = (details) => {
    document.querySelectorAll('header-menu > details[open]').forEach((openDetails) => {
      if (openDetails !== details) closeDropdown(openDetails);
    });

    details.setAttribute('open', '');
    details.querySelector(':scope > summary')?.setAttribute('aria-expanded', 'true');
  };

  const initializeDropdownHover = (root = document) => {
    root.querySelectorAll('header-menu').forEach((menu) => {
      if (menu.dataset.dropdownHoverInitialized === 'true') return;

      const details = menu.querySelector(':scope > details');
      if (!details) return;

      let closeTimer;

      menu.addEventListener('mouseenter', () => {
        if (!desktopQuery.matches) return;
        window.clearTimeout(closeTimer);
        openDropdown(details);
      });

      menu.addEventListener('mouseleave', () => {
        if (!desktopQuery.matches) return;
        window.clearTimeout(closeTimer);
        closeTimer = window.setTimeout(() => closeDropdown(details), 200);
      });

      menu.dataset.dropdownHoverInitialized = 'true';
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeDropdownHover());
  } else {
    initializeDropdownHover();
  }

  document.addEventListener('shopify:section:load', (event) => initializeDropdownHover(event.target));
})();
